import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewEncapsulation,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {CcBaseComponent} from "../../../../crystal-elements/cc-base.component";
import {ClearingSelectionSummary} from "../../../../model/clearing/clearing-selection-summary";
import {AppConfigService} from "../../../../services/app-config.service";

@Component({
  selector: 'app-clearing-selection-summary',
  templateUrl: './selection-summary.component.html',
  styleUrls: ['./selection-summary.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SelectionSummaryComponent extends CcBaseComponent {

  @Input()
  showLoadingSpinner: boolean = false;

  @Input()
  isDark: boolean = false;

  @Input()
  summaryBuyValue: ClearingSelectionSummary;
  @Input()
  summarySellValue: ClearingSelectionSummary;
  @Input()
  owner: string;

  averagePriceDecimal: number = 8;

  constructor(cdref: ChangeDetectorRef,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService,
              private appConfigService: AppConfigService) {
    super(cdref, messageService, translateService);

  }

  protected initData() {
    super.initData();

    this.averagePriceDecimal = this.appConfigService.clearingAvgPriceDecimal;
  }
}
